export const COLLECT_ADDRESS = '0xdC7100D8069D6E180a9910E4c3fe2f1ee03467BE';
